import { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  DialogContentText,
  CircularProgress,
} from '@material-ui/core';
import RoundedButton from 'components/Shared/RoundedButton';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  actions: {
    justifyContent: 'space-between',
    padding: theme.spacing(1, 3, 2, 3),
  },
  progress: {
    color: theme.palette.common.white,
  },
}));

let timeoutID;

const IdleDialog = ({
                      open,
                      logout,
                      onClose,
                      onLogout,
                      logoutTimeout,
                      ...rest
                    }) => {
  const { en: { btn, dialogs } } = useSelector((state) => state.i18n);
  const { isTabActive } = useSelector((state) => state.appSettings);
  const classes = useStyles();
  const [counter, setCounter] = useState(logoutTimeout);
  const intervalRef = useRef();

  useEffect(() => {
    if (counter <= 0) {
      onLogout('#auto_logout');
    }
  }, [counter]);

  const checkAuthTime = async () => {
    intervalRef.current = setInterval(() => {
      setCounter((localStorage.getItem('authorizationExpiresTimeout') - Date.now()) / 1000);
    }, 1000);

    timeoutID = setTimeout(() => {
      if (localStorage.getItem('authorizationExpiresTimeout') - Date.now() <= 0) {
        onLogout('#auto_logout');
      }
    }, logoutTimeout * 1500);
  };

  useEffect(() => {
    if (isTabActive && open) {
      clearTimeout(timeoutID);
      clearInterval(intervalRef.current);
      checkAuthTime();
    }
  }, [isTabActive]);

  useEffect(() => {
    if (open) {
      checkAuthTime();
    } else {
      clearTimeout(timeoutID);
      clearInterval(intervalRef.current);
      setCounter(logoutTimeout);
    }
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
      }}
      aria-labelledby='idle-title'
      fullWidth
      maxWidth='xs'
      disableBackdropClick
      disableEscapeKeyDown
      {...rest}
    >
      <DialogTitle id='idle-title'>{dialogs.sessionTimeout}</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogs.inactivityWarning}</DialogContentText>
      </DialogContent>
      <DialogActions classes={{ root: classes.actions }}>
        <RoundedButton
          onClick={() => logout('#logout_without_notification')}
          variant='contained'
          color='secondary'
          size='small'
        >
          {btn.logOut}
        </RoundedButton>
        <RoundedButton
          onClick={onClose}
          variant='contained'
          color='primary'
          size='small'
          endIcon={
            <CircularProgress
              variant='static'
              value={Math.round((counter / logoutTimeout) * 100)}
              size={18}
              className={classes.progress}
            />
          }
        >
          {btn.stayLoggedIn}
        </RoundedButton>
      </DialogActions>
    </Dialog>
  );
};

export default IdleDialog;
